// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"911df453","787":"9286e546","802":"bd7e4ab8"}[chunkId] + ".chunk.js";
};